import { Requests } from "../common/request.common";
import { ScheduleTimeTableResponseTypes } from "../common/response.common";
import { post } from "./common";

export const scheduleTimeTable = {
    weekEntries(data: typeof Requests.ScheduleTimeTable.WeekEntries.Input) {
        return post<typeof data, ScheduleTimeTableResponseTypes.WeekEntries>(
            "/schedule-time-table/week-record",
            data,
        );
    },
    dayEntries(data: typeof Requests.ScheduleTimeTable.DayEntries.Input) {
        return post<typeof data, ScheduleTimeTableResponseTypes.DayEntries>(
            "/schedule-time-table/date-record",
            data,
        );
    },
    options(data: typeof Requests.ScheduleTimeTable.Options.Input) {
        return post<typeof data, ScheduleTimeTableResponseTypes.Options>(
            "/schedule-time-table/option/schedules",
            data,
        );
    },
    assign(data: typeof Requests.ScheduleTimeTable.Assign.Input) {
        return post<typeof data>("/schedule-time-table/assign", data);
    },
    unassign(data: typeof Requests.ScheduleTimeTable.Unassign.Input) {
        return post<typeof data>("/schedule-time-table/unassign", data);
    },
    edit(data: typeof Requests.ScheduleTimeTable.Edit.Input) {
        return post<typeof data>("/schedule-time-table/edit", data);
    },
    verifyCopy(data: typeof Requests.ScheduleTimeTable.VerifyCopy.Input) {
        return post<typeof data, ScheduleTimeTableResponseTypes.VerifyCopy>(
            "/schedule-time-table/copy-verify",
            data,
        );
    },
    copy(data: typeof Requests.ScheduleTimeTable.Copy.Input) {
        return post<typeof data>("/schedule-time-table/copy", data);
    },
};
